module.exports = __webpack_public_path__ + "media/packs/images/flags/IS-e42a23b46e56bfaa5ee78f95b44e3fc6.png";